import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Cognito hosted-UI OAuth redirect target. Amplify processes the authorization code on load; once the
 * session is established we send the user back to the home page (now signed in, so gated articles show).
 */
@Component({
  selector: 'app-callback',
  template: '<div class="hc-loading"><mat-progress-spinner mode="indeterminate" diameter="36"></mat-progress-spinner></div>',
  standalone: false,
})
export class CallbackComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    // Give Amplify a tick to exchange the code, then return home.
    setTimeout(() => this.router.navigate(['/']), 600);
  }
}
